import React, { PropTypes, Component } from "react";
import styled from 'styled-components';

import {
  SidePanelHeader,
  GenericTable,
  SummaryTable,
  GenericPie,
  Card,
  Steps,
  GroupBox,
  PanelActionButton,
  TabsArray,
  TablePanel
} from "../factoryComponents";
import { VehicleDetails, RegoPlate, CardBlock } from "../vehicle";
import { DriverDetailsCard } from "../driver";
import ComparisonMeter from "../comparison/ComparisonMeter";

import {
  NitroHeading,
  NitroDivider,
  NitroLoading,
  NitroParagraph
} from "nitro-components";

class RemoteLoader extends Component {
  render() {
    const { navTitle } = this.props;

    return (
      <div>
        <NitroHeading label={navTitle} size="1" align="center" noMargin />
        <NitroDivider noTopPad halfWidth />
        <NitroLoading position="center" />
      </div>
    );
  }
}

RemoteLoader.propTypes = {
  navTitle: PropTypes.string
};

const Total = styled.span`
  margin-left: 8px;
  float: left;
`;

class ComponentFactory extends Component {
  render() {
    const {
      Columns,
      Rows,
      Header,
      Title,
      Footers,
      Data,
      Children,
      drillDown,
      drillUp,
      fetchSummaryDetails,
      FetchParams,
      HeaderPostFix,
      title,
      navTitle,
      Variant,
      IndicatorHeader,
      gridAction,
      ActionDetails,
      ...component
    } = this.props;

    const DisplayType = component["@DisplayType"];

    const isRootComponent = title && !navTitle;

    let componentRenderer;
    let total = '';

    switch (DisplayType) {
      case 'table':
        if (Footers != null) {
          let columnDataType= Columns.find(c=>c['@Name']==='Total');
          let footerTotal = Footers.find(o => o.Type === 'Total');
          //footerTotal=(title==='Infringements Trend' || title==='Fuel Exceptions Trend' || title==='Registrations Overdue' || title==='Services Overdue Trend') ? footerTotal=parseInt(footerTotal.Total) :  parseFloat(footerTotal.Total).toFixed(2);
          if(columnDataType && footerTotal)
            footerTotal=(columnDataType['@DataType']!==undefined && columnDataType['@DataType']==='Currency') ?
              parseFloat(footerTotal.Total).toFixed(2)
              : footerTotal=parseInt(footerTotal.Total);

          total = (footerTotal && footerTotal != null) ? `Total :  ${footerTotal}` : '';
        }

        componentRenderer = (
          <div>
            <GenericTable
              showHeader={DisplayType !== 'summary-table'}
              headers={Columns}
              rows={Rows}
              drillDown={drillDown}
              handleBackClick={drillUp}
              category={Header}
              HeaderPostFix={HeaderPostFix}
              title={title}
              // navTitle only get set after user drill down
              navTitle={navTitle}
              Variant={Variant}
              IndicatorHeader={IndicatorHeader}
              // for notification
              action={gridAction}
              fromNotification={this.props.isFromNotification}
              ActionDetails={ActionDetails}
            />

          <Total>
            <NitroHeading size="3" label={total} align="left" />
          </Total>
          </div>
        );
        break;

      case "table-panel":
       componentRenderer = (
          <TablePanel {...this.props} />

        );
       break;
      case "summary-table":
        componentRenderer = (
          <SummaryTable
            headers={Columns}
            rows={Rows}
            drillDown={drillDown}
            handleBackClick={drillUp}
            category={Header}
            HeaderPostFix={HeaderPostFix}
            title={title}
            // navTitle only get set after user drill down
            navTitle={navTitle}
            ExtraSpacingRows={component.ExtraSpacingRows}
            footerDivider={component.footerDivider}
            formatting={component.formatting}
          />
        );
        break;
      case "pie":
        componentRenderer = (
          <GenericPie
            dataType={component["@DataType"]}
            data={Data}
            title={Header}
            HeaderPostFix={HeaderPostFix}
            navTitle={navTitle}
            handleBackClick={drillUp}
          />
        );
        break;
      case "navigation-header":
        // componentRenderer = <NitroHeading label={Title} size="4" align="left" noMargin/>;
        componentRenderer = (
          <SidePanelHeader
            drilldownTitle={navTitle}
            drillUp={drillUp}
            rootTitle={Title}
          />
        );
        break;
      case "text-block":
        componentRenderer = (
          <section>

            <NitroHeading
              label={Header}
              size="2"
              align="center"
              noMargin
              variant={component.IsRootHeader ? "secondary" : ""}
            />
            {// walkaround to display navigation title and divider when text-block is the root component
            (isRootComponent || component.IsRootHeader) &&
              <NitroDivider noTopPad sidePanel />}

            <NitroParagraph align="center" variant="base3">
              {component.SubHeader}
            </NitroParagraph>
          </section>
        );
        break;
      case "remote":
        componentRenderer = (
          <RemoteLoader
            {...{ fetchSummaryDetails, navTitle, FetchParams, ...component }}
          />
        );
        break;
      case "card":
        componentRenderer = <Card children={Children} {...component} />;
        break;
      case "vehicle-card":
        componentRenderer = (
          <VehicleDetails {...component} horizontal showInfo />
        );
        break;
      case "rego-block":
        componentRenderer = <RegoPlate value={Header} active />;
        break;
      case "card-block":
        componentRenderer = (
          <CardBlock
            Label={Math.round(component.Label)}
            Description={component.Description}
            Variant={Variant}
            Icon={component.Icon}
          />
        );
        break;
      case "driver-card":
        componentRenderer = (
          <DriverDetailsCard
            {...component}
            DriverFullName={`${component.DriverFirstName} ${component.DriverLastName}`}
            driverId={component.DriverID}
            horizontal
            padding={28}
            DriverIcon={component.DriverIcon}
            DriverVariant={component.DriverVariant}

          />
        );
        break;
      case "steps":
        componentRenderer = <Steps steps={component.Step} />;
        break;
      case "group-box":
        componentRenderer = <GroupBox children={Children} />;
        break;
      case "meter-comparison":
        componentRenderer = (
          <ComparisonMeter
            {...component}
            MeterData={Children}
            Bottom={30}
            Top={20}
          />
        );
        break;
      case "callToAction":
        componentRenderer = null;
        break;

      case "tabs-array":
        componentRenderer = <TabsArray {...component} />;
        break;
      case "action-button":
        componentRenderer = <PanelActionButton {...component} />;
        break;
      default:
        componentRenderer = (
          <div>
            <NitroHeading label={navTitle} size="1" align="center" noMargin />
            <NitroDivider noTopPad halfWidth />
            {JSON.stringify(
              {
                Columns,
                Rows,
                Header,
                Footers,
                Data,
                FetchParams,
                ...component
              },
              null,
              2
            )}
          </div>
        );
    }

    return componentRenderer;
  }
}

ComponentFactory.propTypes = {
  Columns: PropTypes.array,
  Rows: PropTypes.array,
  navTitle: PropTypes.string,
  title: PropTypes.string,
  Header: PropTypes.string,
  Title: PropTypes.string,
  Footers: PropTypes.array,
  Data: PropTypes.array,
  Children: PropTypes.array,
  drillDown: PropTypes.func,
  drillUp: PropTypes.func,
  FetchParams: PropTypes.object,
  HeaderPostFix: PropTypes.string,
  Variant: PropTypes.string,
  IndicatorHeader: PropTypes.object,
  idx: PropTypes.number,
  fetchSummaryDetails: PropTypes.func,
  gridAction: PropTypes.func,
  isFromNotification: PropTypes.bool,
  ActionDetails: PropTypes.object
};

export default ComponentFactory;



// WEBPACK FOOTER //
// ./src/components/utils/ComponentFactory.js